export function resolveAiLimitMessage(payload, t, fallbackRequestType = '') {
  const requestType = String(payload?.requestType || fallbackRequestType || '').trim().toLowerCase();
  const key = requestTypeToI18nKey(normalizeRequestType(requestType));
  return t(key);
}

function normalizeRequestType(requestType) {
  switch (requestType) {
    case 'interpret':
    case 'interpret_total':
    case 'interpretation_total':
      return 'interpretation';
    case 'deep_explain':
      return 'deep_explain_total';
    case 'chat':
    case 'chat_stream':
      return 'chat_total';
    case 'search':
      return 'context_search';
    case 'search_stream':
      return 'context_search_stream';
    case 'image':
      return 'verse_image';
    default:
      return requestType;
  }
}

function requestTypeToI18nKey(requestType) {
  switch (requestType) {
    case 'interpretation':
      return 'dailyInterpretationLimitReached';
    case 'deep_explain_total':
      return 'dailyDeepExplainLimitReached';
    case 'chat_total':
      return 'dailyChatLimitReached';
    case 'context_search':
      return 'dailyContextSearchLimitReached';
    case 'context_search_stream':
      return 'dailyContextSearchStreamLimitReached';
    case 'verse_image':
      return 'dailyVerseImageLimitReached';
    default:
      return 'dailyAiTypedLimitReached';
  }
}
